import React from "react";
import "./Updates.scss";

import UpdateItem from "components/UpdateItem";

import UPDATES from "constants/updates";

class Updates extends React.Component {
  render() {
    return (
      <div className="Updates">
        {UPDATES.reverse().map((update, i) => (
          <UpdateItem key={i} {...update} />
        ))}
      </div>
    );
  }
}

export default Updates;
